module.exports = __webpack_public_path__ + "static/media/restore.d901f4b1.svg";